// **** import modules ****
import $ from "jquery";

// **** process ****
export default {
	init() {
		this.$element = $("#comments");
		if(!this.$element.length) {
			return false;
		}
		
		const $title = this.$element.children(".comments-title");
		const $body = this.$element.children(".comments-body");
		const $toggleBtn = $title.children(".toggle-button");
		
		$toggleBtn.on("click", e => {
			e.preventDefault();
			
			if( $body.is(":hidden") ) {
				$toggleBtn.addClass("is-open");
				$body.slideDown(400);
				
			} else {
				$toggleBtn.removeClass("is-open");
				$body.slideUp(400);
			}
		})
	}
}
